import { isProductionEnvironment } from '@luminovo/commons';

import { logToExternalErrorHandlers } from './logToExternalErrorHandlers';

export const throwErrorUnlessProduction = (error: unknown): void => {
    if (!isProductionEnvironment()) {
        /* oxlint-disable-next-line no-console */
        console.error(error);
        alert(error);
        throw error;
    }
    if (isProductionEnvironment()) {
        logToExternalErrorHandlers(new Error(String(error)));
    }
};
